import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { MediaAudioContentTypeEnum, MediaTypeEnum } from 'constants-media';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    default: MediaTypeEnum.Audio,
    validators: [
      {
        name: 'In',
        value: [MediaTypeEnum.Audio],
      },
    ],
  },
  contentType: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: Object.values(MediaAudioContentTypeEnum),
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use AudioType from application-types instead.
 */
export class AudioType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  superUserOnly = true;

  name = 'Audio';

  friendlyName = 'Audio';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Audio from application-types instead.
 */
const definition = new AudioType();

Types.addBaseType(definition);

export default definition;
